// pages/users/SuperDistributorsPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function SuperDistributorsPage() {
  return <UserRolePage role="super_distributor" title="Super Distributors" accentColor="#0891b2"
    roleOptions={['super_distributor']} />;
}